import * as React from 'react'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import { useDispatch, useSelector } from 'react-redux'
import { getSelectedTab, setTab } from '../../redux/modules/app'

function a11yProps(index: number) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  }
}

export default function FullWidthTabs() {
  const dispatch = useDispatch()
  const selectedTab = useSelector(getSelectedTab)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    dispatch(setTab(newValue))
  }

  const theme = createTheme({
    components: {
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: 'transparent',
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          indicator: {
            backgroundColor: 'yellow',
          },
        },
      },
    },
  })

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ width: '100%' }}>
        <AppBar position="static">
          <Tabs
            value={selectedTab}
            onChange={handleChange}
            indicatorColor="secondary"
            textColor="inherit"
            variant="fullWidth"
            aria-label="full width tabs example"
          >
            <Tab label="LOANS" {...a11yProps(0)} />
            <Tab label="ARBITRAGE" {...a11yProps(1)} />
          </Tabs>
        </AppBar>
      </Box>
    </ThemeProvider>
  )
}
